import script from "./bonusomat-slots-win-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./bonusomat-slots-win-table.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__